import * as types from "../ActionType";
import axios from "axios";
import { notifyError , notifysuccess } from "../../components/general/Notification";
import { hasExpirition } from "../../components/general/general-component/abstruct-component/useExpirition";
import { removeCommas } from "../../components/general/general-component/abstruct-component/FunctionRemoveCommas";
const END_POINT = process.env.REACT_APP_BASE_URL_ACCOUNTING;

const add = (type) => {
    return ({
        type: type
    })
}
const get = (arr,type) => {
    return ({
        type: type,
        payload: arr
    })
}
const delelte = (type) => {
    return ({
        type: type
    })
}
const edit= (type) => {
    return ({
        type: type 
    })
}
const emptyGeneral = (empty, typee) => {
    return ({
        type: typee,
        payload: empty
    })
}

export const postAccount = (state,setLoad) => {
    return function (dispatch) {
        setLoad(true)
        let user_id = localStorage.getItem('XX')
        let token = localStorage.getItem("tokenA");
        let newAmount = removeCommas(state.amount);
        const body={
            name: state.name,
            type: state.type,
            amount: parseInt(newAmount),
            status: state.status,
            user_id: state.user_id,
            account_type_id: state.account_type_id
        }
        console.log(body)
        axios.post(`${END_POINT}/api/accounts`, body, {
            headers: {
                'Authorization': `Bearer ${token}`,
                "X-User-Id": user_id
            }
        }).then((res) => {
            if (res.data.status === "Success") {
                dispatch(add(types.ADD_ACCOUNT));
                dispatch(loadAccounts());
                notifysuccess(res.data.message)
                setLoad(false)
            }
        }).catch((err) => {
            setLoad(false)
            console.log(err)
            notifyError(err.response.data.message)
        })
    }
}
export const getPageList = () => {
    return function (dispatch) {
        let token = localStorage.getItem("tokenA");
        axios.get(`${END_POINT}/api/accounts/create`, {
            headers: {
                'Authorization': `Bearer ${token}`
            }
        }).then((res) => {
            if (res.data.status == "Success") {
                dispatch(get(res?.data?.data,types.PAGE_LIST_ACCOUNTS));
            }
        }).catch((err) => {
            notifyError(err.response.data.message)
        })
    }
}
export const loadAccounts = () => {
    return function (dispatch) {
        let token = localStorage.getItem("tokenA");
        axios.get(`${END_POINT}/api/accounts`, {
            headers: {
                'Authorization': `Bearer ${token}`
            }
        }).then((res) => {
            if (res.data.status == "Success") {
                dispatch(get(res.data.data,types.GET_ACCOUNTS));
            }
        }).catch((err) => {
            notifyError(err.response.data.message)
        })
    }
}
export const loadStatementsByAccount = (id) => {
    return function (dispatch) {
        let token = localStorage.getItem("tokenA");
        axios.get(`${END_POINT}/api/accounts/${id}/expense-statements`, {
            headers: {
                'Authorization': `Bearer ${token}`
            }
        }).then((res) => {
            if (res.data.status == "Success") {
                dispatch(get(res.data.data, types.GET_STATEMENTS_BY_ACCOUNT));
            }
        }).catch((err) => {
            notifyError(err.response.data.message)
        })
    }
}
export const emptyStatementsByAccount = () => {
    return function (dispatch) {
        let emptyy = {}
        dispatch(emptyGeneral(emptyy, types.EMPTY_STATEMENTS_BY_ACCOUNT))
    }
}
export const loadStatementsReportByAccount = (id,expense_statements_ids,setLoad) => {
    return function (dispatch) {
        let token = localStorage.getItem("tokenA");
        setLoad(true)
        axios.post(`${END_POINT}/api/accounts/${id}/expense-statements/report`,{expense_statements_ids}, {
            headers: {
                'Authorization': `Bearer ${token}`
            }
        }).then((res) => {
            if (res.data.status == "Success") {
                dispatch(get(res.data.data, types.GET_STATEMENTS_REPORT_BY_ACCOUNT));
                setLoad(false)
            }
        }).catch((err) => {
            setLoad(false)
        })
    }
}
export const emptyStatementsReportByAccount = () => {
    return function (dispatch) {
        let emptyy = null
        dispatch(emptyGeneral(emptyy, types.EMPTY_STATEMENTS_REPORT_BY_ACCOUNT))
    }
}
export const loadOneAccount = (id) => {
    return function (dispatch) {
        let token = localStorage.getItem("tokenA");
        axios.get(`${END_POINT}/api/accounts/${id}`, {
            headers: {
                'Authorization': `Bearer ${token}`
            }
        }).then((res) => {
            if (res.data.status == "Success") {
                dispatch(get(res.data.data,types.GET_ONE_ACCOUNT));
            }
        }).catch((err) => {
            notifyError(err.response.data.message)
        })
    }
}
export const emptyOneAccount = () => {
    return function (dispatch) {
        let emptyy = {}
        dispatch(emptyGeneral(emptyy, types.EMPTY_ONE_ACCOUNT))
    }
}

export const deleteAccount= (id,setloadDel,setIsDeleted,setIdDeleted) => {
    return function (dispatch) {
        let token = localStorage.getItem("tokenA");
        setloadDel(true)
        axios.delete(`${END_POINT}/api/accounts/${id}`, {
            headers: {
                'Authorization': `Bearer ${token}`
            }
        }).then((res) => {
            if (res.data.status == "Success") {
                dispatch(delelte(types.DELETE_ACCOUNT));
                notifysuccess(res.data.message)
                //dispatch(loadUsers());
                setIsDeleted('deleted')
                setIdDeleted(id)
                setloadDel(false)
            }
        }).catch((err) => {
            setloadDel(false)
            notifyError(err.response.data.message)
        })
    }
}

export const putAccount = (id,state,setLoad) => {
    return function (dispatch) {
        setLoad(true)
        let token = localStorage.getItem("tokenA");
        const body={
            name: state.name,
            type: state.type,
            amount: parseInt(removeCommas(state.amount)),
            status: state.status,
            user_id: state.user_id,
            account_type_id: state.account_type_id
        }
        console.log(body)
        axios.put(`${END_POINT}/api/accounts/${id}`,body, {
            headers: {
                'Authorization': `Bearer ${token}`
            }
        }).then((res) => {
            if (res.data.status === "Success") {
                dispatch(edit(types.EDIT_ACCOUNT));
                dispatch(loadAccounts());
                notifysuccess(res.data.message)
                setLoad(false)
            }
        }).catch((err) => {
            setLoad(false)
            notifyError(err.response.data.message)
        })
    }
}


export const filterAccount = (name,type,user_id,status, setLoad) => {
    return function (dispatch) {
        let token = localStorage.getItem("tokenA")
        setLoad(true);
        const queryParams = [];
        if (name !== '') queryParams.push(`filters[name]=${name}`);
        if (type !== '') queryParams.push(`filters[account_type_id]=${type}`);
        if (user_id !== '') queryParams.push(`filters[user_id]=${user_id}`);
        if (status !== '') queryParams.push(`filters[status]=${status}`);
        const finalQuery = queryParams.join('&');
        const apiUrl = `${END_POINT}/api/accounts?${finalQuery}`;
        axios.get(apiUrl, {
            headers: {
                "Authorization": `Bearer ${token}`
            }
        }).then((res) => {
            setLoad(false);
             dispatch(get(res.data.data,types.GET_ACCOUNTS));
        }).catch((err) => {;
            setLoad(false);
        });
    };
};
